module.exports = __webpack_public_path__ + "img/military.6718fa3a.png";